import React from 'react'
import ReactDOM from 'react-dom'
import * as Sentry from '@sentry/react'
import { BrowserRouter } from 'react-router-dom'

import App from 'App'
import { AuthProvider } from 'hooks/useAuth'
import { FirebaseAppProvider } from 'hooks/useFirebaseApp'
import * as serviceWorker from 'serviceWorker'
import 'reset.css'

Sentry.init({
  dsn: 'https://ec24d50f1a8d46009e8a8a1268a58948@o416933.ingest.sentry.io/5314341',
  environment: process.env.NODE_ENV,
})

ReactDOM.render(
  <BrowserRouter>
    <FirebaseAppProvider>
      <AuthProvider>
        <App />
      </AuthProvider>
    </FirebaseAppProvider>
  </BrowserRouter>,
  document.getElementById('root')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
